import React from "react";
import Shade from "/Users/therendysuffren/Desktop/Web developer Projects/amazon-starterpack/src/assets/shade.png";
import css from "./Virtual.module.css";
import ReactCompareImage from "react-compare-image";
import Before from "/Users/therendysuffren/Desktop/Web developer Projects/amazon-starterpack/src/assets/before.png";
import After from "/Users/therendysuffren/Desktop/Web developer Projects/amazon-starterpack/src/assets/after.png";

const Virtual = () => {
  return (
    <div className={css.Virtual}>
      <div className={css.left}>
        <span>Virtual Try-on</span>
        <span>Never Buy the wrong Shade Again!</span>
        <span>Try Now!</span>
        <img src={Shade} alt="" />
      </div>

      <div className={css.right}>
        <div className={css.wrapper}>
          <ReactCompareImage leftImage={Before} rightImage={After} />
        </div>
      </div>
    </div>
  );
};

export default Virtual;
